import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { ComplianceCardData, compliantStatuses } from "../../../utils/complianceUtils";
import { isDefined } from "../../Generic/IsDefined";
import ComplianceItemCardUI from "./ComplianceItemCardUI";

type Props =
  | {
      isLoading: true;
    }
  | (ComplianceCardData & {
      isLoading: false;
      onClick: () => void;
    });

function ComplianceItemCard(props: Props) {
  if (props.isLoading) {
    return <ComplianceItemCardUI isLoading />;
  }

  const rejectReason = compliantStatuses.includes(props.item.complianceStatus)
    ? null
    : props.item.uploads.find((upload) => upload.status === "Rejected")?.rejectReason ?? null;

  const icon = getIcon(props);

  const footer = getFooter(props);

  return (
    <ComplianceItemCardUI
      isLoading={false}
      title={props.item.documentType.name}
      subTitle={props.subTitle}
      icon={icon}
      errorMessage={rejectReason}
      footer={footer}
      onClick={props.onClick}
    />
  );
}

function getIcon(props: Props) {
  if (props.isLoading) {
    return null;
  }

  switch (props.type) {
    case "compliant":
      return "success" as const;

    case "pending":
      return "info" as const;

    case "issue":
      return "error" as const;

    case "expiresSoon":
    case "dueSoon":
      return "warning" as const;
  }
}

function getFooter(props: Props & { isLoading: false }) {
  switch (props.type) {
    case "expiresSoon":
    case "dueSoon":
    case "issue":
      return {
        type: "fixIssue" as const,
        text: isDefined(props.item.referenceDocumentData?.referenceLink)
          ? translate(STRINGS.SHARE_THE_REFERENCE_LINK_TO_SPEED_THINGS_UP)
          : props.item.documentType.isFillable
          ? translate(STRINGS.SIXTY_SECONDS_AND_YOU_ARE_DONE)
          : "",
      };

    case "compliant":
    case "pending":
      return { type: "view" as const };
  }
}

export default ComplianceItemCard;
